import { cn } from "@/lib/class-control";
import { ReactNode } from "react";

export function Container({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn("h-screen lg:max-w-screen-2xl mx-auto", className)}>
      {children}
    </div>
  )
}